import { useSyncExternalStore } from 'react'

import { StepController } from './StepsController'

const stepController = new StepController()

const methods = {
  addNextStep: stepController.addNextStep.bind(stepController),
  goToStep: stepController.goToStep.bind(stepController),
  getStep: stepController.getStep.bind(stepController),
  setContextToActiveStep: stepController.setContextToActiveStep.bind(stepController),
}

export const useStepController = () =>
  useSyncExternalStore(
    stepController.subscribe.bind(stepController),
    stepController.getSnapshot.bind(stepController),
  )

export const useStepControllerMethods = () => methods
